import React from "react";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-heading text-xl md:text-2xl font-bold text-navy mb-3">{title}</h2>
    <div className="text-sm text-foreground/80 leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <section className="bg-navy text-white section-pad">
        <div className="container-x">
          <span className="accent-bar mb-4" />
          <h1 className="font-heading text-4xl md:text-5xl font-extrabold tracking-tight">Privacy Policy</h1>
          <p className="text-white/70 mt-3 text-sm">Last updated: February 2026</p>
        </div>
      </section>
      <section className="container-x section-pad max-w-4xl">
        <Section title="1. Information We Collect">
          <p>We collect personal and business information that you voluntarily provide through our lead form, email, phone calls or WhatsApp — including name, email, phone, business type, loan requirement, financial documents and KYC details.</p>
        </Section>
        <Section title="2. How We Use Information">
          <p>Information is used solely to evaluate your funding requirement, share your case with appropriate partner lenders, and communicate updates on your application. We may also use it for internal record keeping and regulatory compliance.</p>
        </Section>
        <Section title="3. Sharing With Lenders">
          <p>To facilitate funding, we share relevant information with our network of banks, NBFCs and private financiers. These partners are expected to maintain confidentiality and use the data solely for credit appraisal.</p>
        </Section>
        <Section title="4. Data Security">
          <p>We employ reasonable technical and organizational safeguards to protect your data from unauthorized access, alteration or disclosure. However, no method of transmission over the Internet is 100% secure.</p>
        </Section>
        <Section title="5. Cookies & Analytics">
          <p>Our website may use cookies and analytics tools to improve user experience. You may disable cookies via your browser settings, though some features may not function optimally.</p>
        </Section>
        <Section title="6. Your Rights">
          <p>You may request access, correction or deletion of your personal data at any time by emailing support@crewconnectfininvesto.com. Some data may need to be retained for legal/regulatory reasons.</p>
        </Section>
        <Section title="7. Third-Party Links">
          <p>Our website may contain links to third-party sites. We are not responsible for the privacy practices of those external sites.</p>
        </Section>
        <Section title="8. Updates">
          <p>We may update this policy periodically. The updated version will be effective from the date posted on this page.</p>
        </Section>
      </section>
    </div>
  );
}
